import * as types from './types';

const getPostingInfo = postingId => {
  return {
    type: types.GET_POSTING_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/getpostinginfo`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getImpressions = postingId => {
  return {
    type: types.GET_IMPRESSIONS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingimpressions`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getVisits = postingId => {
  return {
    type: types.GET_VISITS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingvisits`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getLeads = postingId => {
  return {
    type: types.GET_LEADS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingleads`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getPostingQuality = postingId => {
  return {
    type: types.GET_POSTING_QUALITY,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingquality`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getAuthorization = postingId => {
  return {
    type: types.GET_AUTHORIZATION,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/permissions/${postingId}`,
      method: 'GET'
    }
  };
};

const getLeadsStats = postingId => {
  return {
    type: types.GET_LEADS_STATS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/getpostingleadsstats/${postingId}`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getPostingLogs = postingId => {
  return {
    type: types.GET_POSTING_LOGS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/auditory/${postingId}`,
      method: 'GET'
    }
  };
};

const getPostingTips = postingId => {
  return {
    type: types.GET_POSTING_TIPS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingperformancetips/${postingId}`,
      method: 'GET'
    }
  };
};

const fetchReports = postingId => {
  return {
    type: types.FETCH_REPORTS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/report/${postingId}`,
      method: 'GET',
      postingId
    }
  };
};

const savePostingTag = (postingId, tagId) => {
  return {
    type: types.SAVE_POSTING_TAG,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/tags/${postingId}`,
      method: 'POST',
      query: { tagId, postingId }
    }
  };
};

const checkReport = postingId => ({
  type: types.CHECK_POSTING_REPORT,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v2/postings/checkReport/${postingId}`,
    method: 'POST'
  }
});

const fetchCredits = (queryParams = null) => ({
  type: types.FETCH_CREDITS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/credits',
    query: queryParams,
    method: 'GET'
  }
});

const selectCredit = (publicationPlanId, branchId) => ({
  type: types.SELECT_CREDIT,
  payload: { publicationPlanId, branchId }
});

const publishPosting = publishData => ({
  type: types.PUBLISH_POSTING,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/publish',
    method: 'PUT',
    body: publishData
  }
});

const updatePostingInfo = postingId => {
  return {
    type: types.UPDATE_POSTING_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/getpostinginfo`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const saveSharedPerformance = (postingId, publisherId, dataToShare) => {
  return {
    type: types.SAVE_SHARED_PERFORMANCE,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/sharedperformance/save/${postingId}/${publisherId}`,
      method: 'POST',
      body: dataToShare
    }
  };
};

const getFinishReason = publisherTypeId => {
  return {
    type: types.GET_FINISH_REASON,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/finishReason`,
      method: 'GET',
      query: { publisherTypeId }
    }
  };
};

const suspendPosting = (postings, _, finishReasonId, finishReasonText) => ({
  type: types.SUSPEND_POSTING,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/suspend',
    method: 'PUT',
    body: { postings, finishReasonId, finishReasonText }
  }
});

const sendUnreadLeadsMessagge = (postingIds, customMessage) => ({
  type: types.SEND_UNREAD_LEADS_MSG,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/posting/leads/savePostingIdsToCheckLeads',
    method: 'POST',
    body: { postingIds, customMessage }
  }
});

const setShowUnreadLeadsModal = (showUnreadLeadsModal, postingIds) => ({
  type: types.SHOW_UNREAD_LEADS_MODAL,
  payload: {
    showUnreadLeadsModal,
    postingIds
  }
});

const getUnreadLeads = postingIds => ({
  type: types.HAS_UNREAD_LEADS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/posting/leads/hasUnreadLeads',
    method: 'GET',
    query: { postingIds }
  }
});

const getPostingFullInfo = postingId => {
  return {
    type: types.POSTING_FULL_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postingFull/${postingId}`,
      method: 'GET'
    }
  };
};

export {
  getPostingInfo,
  getImpressions,
  getVisits,
  getLeads,
  getPostingQuality,
  getAuthorization,
  getLeadsStats,
  getPostingLogs,
  getPostingTips,
  fetchReports,
  savePostingTag,
  checkReport,
  fetchCredits,
  selectCredit,
  publishPosting,
  updatePostingInfo,
  saveSharedPerformance,
  getFinishReason,
  suspendPosting,
  sendUnreadLeadsMessagge,
  setShowUnreadLeadsModal,
  getUnreadLeads,
  getPostingFullInfo
};
